export default __webpack_public_path__ + "static/media/face.7c209076.png";